import { useState, useEffect, useRef } from 'react';
import { fmtUnid, aceitaDecimal, fmtNum, lerNum } from '../../utils/especificacao';

/**
 * Campo de quantidade com − e + e a unidade do produto (m², un, cx...). Unidades
 * de área/comprimento aceitam fração (15,5 m²); as outras só inteiro.
 * `onChange` só recebe número válido (> 0).
 */
export default function Quantidade({ valor, unidade, onChange, compacto = false, autoFocus = false }) {
  const dec = aceitaDecimal(unidade);
  const [txt, setTxt] = useState(fmtNum(valor));
  // Valor corrente numa ref: cliques rápidos no +/− somam certo mesmo antes de re-renderizar
  const atual = useRef(valor);
  useEffect(() => { setTxt(fmtNum(valor)); atual.current = valor; }, [valor]);

  const normalizar = (n) => (dec ? Math.round(n * 100) / 100 : Math.round(n));
  const confirmar = (t) => {
    const n = normalizar(lerNum(t));
    if (Number.isFinite(n) && n > 0) { setTxt(fmtNum(n)); atual.current = n; if (n !== valor) onChange(n); }
    else setTxt(fmtNum(valor)); // inválido: volta pro último valor bom
  };
  const passo = (d) => {
    const n = normalizar(atual.current + d);
    if (n <= 0) return;
    atual.current = n;
    setTxt(fmtNum(n));
    onChange(n);
  };

  return (
    <div className={`esp-qtd ${compacto ? 'compacto' : ''}`}>
      <button type="button" onClick={() => passo(-1)} aria-label="Diminuir" disabled={lerNum(txt) <= 1}><i className="bi bi-dash" /></button>
      <input
        value={txt}
        inputMode={dec ? 'decimal' : 'numeric'}
        autoFocus={autoFocus}
        onChange={e => setTxt(e.target.value.replace(/[^\d.,]/g, ''))}
        onBlur={() => confirmar(txt)}
        onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); confirmar(txt); } }}
        aria-label="Quantidade"
      />
      <span className="esp-qtd-un">{fmtUnid(unidade)}</span>
      <button type="button" onClick={() => passo(1)} aria-label="Aumentar"><i className="bi bi-plus" /></button>
    </div>
  );
}
